
import { Component, Vue } from 'vue-property-decorator';
import { Note, Snackbar, EditNoteField, CardColors } from '@/store/types';
import { SnackbarColorTypes, CardColorTypes } from '@/store/types';
import { namespace } from 'vuex-class';
import ColorPickerMenu from './ColorPickerMenu.vue';

const notesModule = namespace('notes');
const globalModule = namespace('global');

@Component({
  components: {
    ColorPickerMenu,
  },
})
export default class NoteModal extends Vue {
  loading = false;
  deleteLoading = false;

  @globalModule.State
  showNoteDialog!: boolean;

  @globalModule.State
  selectedNote!: Note;

  @globalModule.Mutation
  setShowNoteDialog!: (payload: boolean) => void;

  @globalModule.Mutation
  showSnackbar!: (snackbar: Snackbar) => void;

  @globalModule.Mutation
  setNoteField!: (field: EditNoteField) => void;

  @notesModule.Action
  updateNote!: (note: Note) => Promise<Note>;

  @notesModule.Action
  removeNoteAsync!: (id: string) => Promise<string>;

  async saveNote() {
    this.loading = true;
    await this.updateNote(this.selectedNote);
    this.loading = false;
    this.showSnackbar({
      open: true,
      text: 'Note updated',
      color: SnackbarColorTypes.Success,
    });
    this.setShowNoteDialog(false);
  }

  async deleteNote() {
    this.deleteLoading = true;
    await this.removeNoteAsync(this.selectedNote.id);
    this.deleteLoading = false;
    this.showSnackbar({
      open: true,
      text: 'Note removed',
      color: SnackbarColorTypes.Success,
    });
    this.setShowNoteDialog(false);
  }

  updateTitle(value: string) {
    this.setNoteField({
      name: 'title',
      value,
    });
  }

  updateContent(value: string) {
    this.setNoteField({
      name: 'content',
      value,
    });
  }

  colorSelected(color: CardColors) {
    this.setNoteField({
      name: 'color',
      value: CardColorTypes[color],
    });
  }
}
